<template>
    <el-dialog :title="$t('SET_DUEDAYALARM')"
               visible
               width="480px"
               :close-on-click-modal="false"
               append-to-body
               @close="onCancel">
        <div class="info-cls"><i class="el-icon-warning-outline"/>{{ $t('DUEDAY_WARNING')}}</div>
        <el-form label-width="110px" class="duedayAlarmForm">
            <el-form-item :label="$t('TIME_OPTION')">
                <el-radio-group v-model="active">
                    <el-radio :label="1"> {{ $t('STATUS_DAY_UNTILDUE._4') }}</el-radio>
                    <el-radio :label="0">{{ $t('STATUS_DAYS_OVERDUE._3') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-for="(item, index) in datalist[Number(active)]" :key="index" :label="labelFuc(index)">
                <el-input v-model.number="item.value" v-if="active === 0">
                    <template slot="prepend">{{$t('STATUS_DAYS_OVERDUE._1')}}</template>
                    <template slot="append">{{$t('COMMON_DAY')}}</template>
                </el-input>
                <el-input v-model.number="item.value" v-if="active === 1">
                    <template slot="prepend" v-if="$t('STATUS_DAY_UNTILDUE._1') != ''">{{$t('STATUS_DAY_UNTILDUE._1')}}</template>
                    <template slot="append">{{$t('STATUS_DAY_UNTILDUE._5')}}</template>
                </el-input>
            </el-form-item>
      </el-form>
      <el-button type="primary"
                @click="onConfirm()"
                :loading="saveLoading"
                class="wl-green confirmBut">{{$t('btn_save')}}</el-button>
    </el-dialog>
</template>
<script>
    import API from '@/api'
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                active: 1,
                saveLoading: false,
                datalist: [
                    [{value: 0},{value: 0},{value: 0}],
                    [{value: 0},{value: 0},{value: 0}],
                ]
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getSite: 'getSite'
            }),
            lang() {
                return this.$i18n.locale
            }
        },
        methods: {
            // 保存
            async onConfirm() {
                let verify = false
                this.datalist.forEach((item, index) => {
                    item.forEach((citem,cindex) => {
                        if(!Number.isInteger(Number(citem.value))) {
                            this.$message.error(this.$t('SET_DUEDAYALARM_MESSAGE3'))
                            verify = true
                            return false
                        }
                    })
                })
                if(verify) {return false}
                let dueDataStr = ''
                let overdueDataStr = ''
                this.datalist.map((item,index) => {
                    item.forEach((cites,cinders) => {
                        if(index == 0){
                            let value0 = ('' + cites.value).trim() === '' || cites.value == null ? 0 : cites.value
                            if(3 === cinders + 1){
                                overdueDataStr = overdueDataStr + value0
                            } else {
                                overdueDataStr = overdueDataStr + value0 + ','
                            }
                        } else{
                            let value1 = ('' + cites.value).trim() === '' || cites.value == null ? 0 : cites.value
                            if(3 === cinders + 1){
                                dueDataStr = dueDataStr + value1
                            } else {
                                dueDataStr = dueDataStr + value1 + ','
                            }
                        }

                    })

                })
                const { data, code } = await API.exchange.setDuedayAlarmConfig({siteId: this.getSite.siteId, overdueAlarmConfig: overdueDataStr,dueAlarmConfig: dueDataStr})
                if (code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.onCancel()
                } else {
                    this.$message.error(this.$t(code))
                }
            },
            async getData() {
                const { data, code } = await API.clientUser.getSiteConfig({param: this.getSite.siteId})
                if (code == '1') {
                    // this.datalist = data
                    if(data.overdueAlarmConfig!= '' && data.overdueAlarmConfig != null){
                        let list = data.overdueAlarmConfig.split(',')
                        list.forEach((item,index) => {
                            this.datalist[0][index].value = item
                        })
                    }
                    if(data.dueAlarmConfig!= '' && data.dueAlarmConfig != null){
                        let list = data.dueAlarmConfig.split(',')
                        list.forEach((item,index) => {
                            this.datalist[1][index].value = item
                        })
                    }
                } else {
                    this.$message.error(this.$t(code))
                }
            },
            // 设置页面label
            labelFuc(index) {
                let message = ''
                if(this.lang === 'en') {
                    if(index === 0) { message = '1st'}
                    if(index === 1) { message = '2nd'}
                    if(index === 2) { message = 'Last'}
                } else {
                    message = index === 2 ? '最后 1 次' : '第 ' + (index + 1) + ' 次'
                }
                return this.$t('COMMON_PERIOD', {msg: message })
            }
        },
        mounted() {
            this.getData()
        },
        props: {
            onCancel: Function
        }
    }
</script>
<style scoped>
    .dialogRow {
        height: 60vh;
    }
    .confirmBut {
        position: absolute;
        right: 50px;
        bottom: 25px;
    }
    .duedayAlarmForm {
        height: 245px;
    }
    .duedayAlarmForm ::v-deep .el-input-group {
        width: calc(100% - 30px);
    }
    .info-cls{
        margin: 15px 0;
        text-align: center;
        font-size: 12px;
        color:#fd349c;
    }
    ::v-deep .el-dialog__body{
        padding: 15px;
    }
    ::v-deep .el-input-group__prepend{
        width: 140px;
    }
</style>
